import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { Subscription } from 'rxjs';
import { CommentModelDTO } from '../../dtos/comment.dto';
import { CoachingLogPusherService } from '../../services/coaching-log/coaching-log-pusher.service';

import { CommentsService } from '../../services/comments/comments.service';

@Component({
  selector: 'app-coaching-log-comments',
  standalone: false,
  templateUrl: './coaching-log-comments.component.html',
  styleUrl: './coaching-log-comments.component.scss',
})
export class CoachingLogCommentsComponent implements OnInit, OnDestroy {
  @Input() commentsActive: boolean;

  @Input() sessionId: number;

  @Output() readonly hideCommentsEvent = new EventEmitter<boolean>();

  commentList: CommentModelDTO[];

  commentRequest: Subscription;

  subs: Subscription[] = [];

  loading: boolean;

  newComment: CommentModelDTO = new CommentModelDTO();

  constructor(
    public commentsService: CommentsService,
    private coachingLogPusherService: CoachingLogPusherService
  ) {}

  ngOnInit(): void {
    this.loading = true;

    this.getComments();

    this.subs.push(
      this.coachingLogPusherService.coachlogCommentsUpdatedNotifier.subscribe(
        () => {
          this.getComments();
        }
      )
    );
  }

  toggleComments(): void {
    this.hideCommentsEvent.emit(true);
  }

  getComments() {
    if (this.commentRequest) this.commentRequest.unsubscribe();
    this.commentRequest = this.commentsService
      .getComments('egrowe_coachlog', this.sessionId)
      .subscribe((response) => {
        if (response) {
          this.commentList = response.items;
        }
      });
    this.subs.push(this.commentRequest);
  }

  saveComment() {
    this.newComment.ref_table = 'egrowe_coachlog';
    this.newComment.ref_table_id = this.sessionId;
    this.commentsService.saveComment(this.newComment).subscribe((result) => {
      if (result.item) {
        this.newComment.comment = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
